import { Fragment } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from '../Pages/Dashboard/DashboardLayout';
import DashboardScreen from '../Pages/Dashboard/DashboardScreen';
import Home from '../Pages/Home';
import Layout from '../Pages/Layout';
import Login from '../Pages/Login';
import { useSelector } from 'react-redux';
import AdminLogin from '../Pages/Admin/Auth/AdminLogin';
import AdminDashboardLayout from "../Compnents/Admin/AdminDashboard/AdminDashboardLayout";
import AdminDasboardScreen from '../Pages/Admin/Dashboard';
import Sidebar from '../Compnents/Admin/AdminDashboard/Sidebar';
import Users from '../Compnents/Admin/Users';
import AdminWithdrawal from '../Compnents/Admin/Withdrawal';
import Commission from '../Compnents/Admin/Commision';
import Orders from '../Compnents/Admin/Orders';
import Coupons from '../Compnents/Admin/Coupons';
import Newsletter from '../Compnents/Admin/Newsletters';
import ProfileSettingScreen from '../Compnents/Dashboard/ProfileSetting';
import ForgotPassword from '../Compnents/Auth/ForgotPassword';
import ResetPassword from '../Compnents/Auth/ResetPassword';
import RefferalUserSale from '../Compnents/Admin/RefferalUserSale';
import Voucher from '../Compnents/Admin/Vouchers';
import UserNotification from '../Compnents/Admin/UserNotification';

const AppRouting = () => {
    const token = useSelector((state) => state.auth.token);
    const adminToken = useSelector((state) => state.admin.token);

    return (
        <Fragment>
            <BrowserRouter>
                <Routes>
                    {/* Root route redirects based on token */}
                    <Route path="/" element={
                        token ? <Navigate to="/dashboard" replace /> :
                            adminToken ? <Navigate to="/admin" replace /> :
                                <Layout />
                    }>
                        {!token && !adminToken && (
                            <>
                                <Route index element={<Home />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/admin-login" element={<AdminLogin />} />
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password" element={<ResetPassword />} />
                            </>
                        )}
                    </Route>

                    {/* User Routes */}
                    {token && !adminToken && (
                        <Route path="/dashboard" element={<DashboardLayout />}>
                            <Route index element={<DashboardScreen />} />
                            <Route path="profile-setting" element={<ProfileSettingScreen />} />
                        </Route>
                    )}

                    {/* Admin Routes */}
                    {adminToken && !token && (
                        <Route path="/admin" element={<Sidebar />}>
                            <Route index element={<AdminDasboardScreen />} />
                            <Route path="users" element={<Users />} />
                            <Route path="coupons" element={<Coupons />} />
                            <Route path="withdrawal" element={<AdminWithdrawal />} />
                            <Route path="settings" element={<Commission />} />
                            <Route path="orders" element={<Orders />} />
                            <Route path="newsletters" element={<Newsletter />} />
                            <Route path="refferal-user-sale" element={<RefferalUserSale />} />
                            <Route path="vouchers" element={<Voucher />} />
                            <Route path="notifications" element={<UserNotification />} />


                        </Route>
                    )}

                    {/* Catch all route */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </Fragment>
    );
};

export default AppRouting;
